import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import Modal from 'components/modal';
import { Errors } from 'components/ui/errors';

export default function VoucherCreationConfirmation({ creating, deal, error, onCancel, onCreate }) {
  let suffix;
  if (deal.displayName) {
    suffix = <span> for <b>{deal.displayName}</b></span>;
  }

  return (
    <React.Fragment>
      <Modal.Header closeButton>
        New Voucher
      </Modal.Header>

      <Modal.Body>
        {error && <Errors errors={['The voucher could not be created.']} />}

        <p>Are you sure you want to create a new voucher{suffix}?</p>
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onCancel} />
        <Button disabled={creating} label="Create Voucher" onClick={onCreate} />
      </Modal.Footer>
    </React.Fragment>
  );
}

VoucherCreationConfirmation.propTypes = {
  creating: PropTypes.bool,
  deal: PropTypes.shape({
    displayName: PropTypes.string,
  }).isRequired,
  error: PropTypes.object,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
};
